export enum TagNames {
    UpdateRequired = 'update_required',
    ToCheck = 'to_check'
}
